import {
  pickBy,
  isEmpty,
  get,
  uniq,
} from 'lodash';
import { getRelativeDateRange } from './date';

export const isNumber = (value) => !['', false, true, null].includes(value) && !Number.isNaN(Number(value));

export const validateNumberSequence = (value) => String(value)
  .split(',')
  .every((num) => isNumber(num));

export const getGroupIds = (active, additional) => {
  if (!additional || isEmpty(active)) return {};

  const groupIds = Object.keys(additional).reduce((accumulator, k) => {
    if (active[k]) {
      const activeIds = active[k].split(',') || [];
      const separator = accumulator ? ',' : '';
      return accumulator + separator + additional[k].values.filter(((v) => activeIds.includes(String(v.id))))
        .reduce((result, { contentGroupIds }) => uniq(result.concat(contentGroupIds)), [])
        .join(',');
    }
    return accumulator;
  }, '');

  const groupsSeparator = active?.groups && groupIds ? ',' : '';
  const groups = get(active, 'groups', '') + groupsSeparator + groupIds;

  return groups ? { groups } : {};
};

export const prepareFilterQueryParams = (params = {}) => {
  const queryParams = {
    ...(params?.type !== 'models' ? { type: params.type } : ''),
  };

  if (params.date && params.type !== 'models') {
    queryParams.dateReleased = getRelativeDateRange(params.date);
  }
  if (params.date && params.type === 'models') {
    queryParams.lastSceneReleaseDate = getRelativeDateRange(params.date);
  }

  if (params.gender && params.gender !== 'any') {
    queryParams.gender = params.gender;
  }

  if (params.groups && validateNumberSequence(params.groups)) {
    queryParams.groupId = params.groups.replace(/,/g, ';');
  }

  if (params.letter && params.letter !== 'ALL') {
    queryParams.firstLetter = params.letter;
  }

  if (params.models && validateNumberSequence(params.models)) {
    queryParams.actorId = params.models;
  }

  if (params.site && validateNumberSequence(params.site)) {
    queryParams.collectionId = params.site;
  }

  if (params.tags && validateNumberSequence(params.tags)) {
    queryParams.tagId = params.tags;
  }

  return pickBy(queryParams);
};

export const transformToQueryString = (params = {}) => {
  const queryParams = { ...params };
  if (queryParams.type === 'actors') {
    delete queryParams.type;
  }

  return `?${new URLSearchParams(queryParams).toString()}`;
};
